/**
 * Created by Ivan on 04/06/2017.
 */
import _ from 'lodash';
import $http from '../../HttpRequest';
class FormData
{
    constructor()
    {
        this.Name = null;
        this.Phone = null;
        this.Email = null;
        this.Subject = null;
        this.Message = null;

        this.regex = {
            email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        };
    }

    send()
    {
        let self = this;
        let data = {
            name : this.Name,
            phone : this.Phone,
            email : this.Email,
            subject : this.Subject || "Mensaje enviado desde el sitio web",
            message : this.Message
        };
        return new Promise( (resolve, reject) => {
            $http.post('/contact', data).then( ( response )=> {
                if( response.status == 200 )
                {
                    resolve(response.data);
                    self.clean();
                }
                else
                {
                    reject(response.statusText);
                }
            }).catch( (err)=>{
                reject(err);
            });

        });
    }

    clean()
    {
        this.Name = null;
        this.Phone = null;
        this.Email = null;
        this.Subject = null;
        this.Message = null;
    }

    valid()
    {
        let patt = new RegExp(this.regex.email);
        return !_.isEmpty( this.Name ) && !_.isEmpty( this.Email ) && !_.isEmpty( this.Message ) && patt.test(this.Email);
    }

    get message()
    {
        return this.Message;
    }

    set message( value )
    {
        this.Message = value;
    }

    get name()
    {
        return this.Name;
    }

    set name( value )
    {
        this.Name = value;
    }

    get phone()
    {
        return this.Phone;
    }

    set phone( value )
    {
        this.Phone = value;
    }

    get email()
    {
        return this.Email;
    }

    set email(  value )
    {
        this.Email = value;
    }

    get subject()
    {
        return this.Subject;
    }

    set subject(  value )
    {
        this.Subject = value;
    }



}

export default FormData;


// WEBPACK FOOTER //
// ./src/components/contactForm/FormData.js